import React from 'react'
import ColorSection from './sections/ColorSection'
import Header from './sections/Header'
import { motion } from 'framer-motion'

function App() {
	return (
		<div className="mx-auto max-w-3xl p-4">
			<Header />
			<motion.div
				initial={{ y: 100, opacity: 0 }}
				animate={{ y: 0, opacity: 1 }}
				transition={{ ease: "circOut"}}
				className="p-4 border rounded-lg border-gray-100"
			>
				<ColorSection />
			</motion.div>
		</div>
	)
}

export default App
